// Single source of truth for team public page block configuration.
// Both PageEditorPage and TeamPublicPageApp reference this.

export const DEFAULT_BLOCK_ORDER = [
  'members',
  'achievements',
  'reviews',
  'student_map',
  'courses',
  'group_classes',
  'faq',
  'contact',
  'community'
]

// Blocks visible by default for new teams (no saved page_design)
export const DEFAULT_VISIBLE_BLOCKS = {
  courses: true,
  members: true,
  group_classes: true
}

/**
 * Merge saved blocks_order with any new blocks added since the team last saved.
 * New blocks are inserted at their default position rather than appended to the end.
 */
export function mergeBlockOrder(savedOrder) {
  const validSaved = (savedOrder || DEFAULT_BLOCK_ORDER).filter(id => DEFAULT_BLOCK_ORDER.includes(id))
  const result = [...validSaved]
  const missing = DEFAULT_BLOCK_ORDER.filter(id => !validSaved.includes(id))

  missing.forEach(missingId => {
    const defaultIndex = DEFAULT_BLOCK_ORDER.indexOf(missingId)
    let insertAt = result.length
    for (let i = defaultIndex - 1; i >= 0; i--) {
      const existingIndex = result.indexOf(DEFAULT_BLOCK_ORDER[i])
      if (existingIndex !== -1) {
        insertAt = existingIndex + 1
        break
      }
    }
    result.splice(insertAt, 0, missingId)
  })

  return result
}
